<template>
<!-- <v-select clearable chips attach small-chips multiple dense
  class='mx-1'
  v-model="selected"
  :items="items"
  item-text="title"
  item-value="id"
  label='Filter by status' >
  <template
      slot="selection"
      slot-scope="{ item, index }" >
      <v-chip small v-if="index < numberOfChipsToShow" :color='item.theme' >
        <span>{{ item.title }}</span>
      </v-chip>
      <span
        v-if="index === numberOfChipsToShow"
        class="grey--text caption"
      >(+{{ value.length - numberOfChipsToShow }} others)</span>
  </template>
</v-select> -->
<div>
<v-chip small
  v-for='item in items' :key='item.id'
  @click='toggleSelected(item)'
  :color='item.theme' dark >
  <v-avatar
    v-if="facets && item.id in facets"
    :class="item.theme" class="darken-2" >{{ facets[item.id] }}</v-avatar>
  {{item.title}}
  <v-icon small
    v-if='isSelected(item)'
    class='mr-1' >check</v-icon>
</v-chip>
<!-- {{selected}} -->
</div>
</template>

<script>
import {STATUSES} from '@/store/constants'

export default {
  name: 'AppointmentFilterPicker',
  props: {
    value: { type: Array, default: () => { return [] } },
    facets: { type: Object, required: false },
    selectAll: { type: Boolean, default: false },
    numberOfChipsToShow: { type: Number, default: 2 }
  },
  data () {
    return {
      selected: []
    }
  },
  mounted () {
    if (this.value) { this.selected = this.value }
    if (this.selectAll) {
      this.selected = Object.keys(STATUSES)
    }
  },
  computed: {
    items () {
      let li = []
      let keys = Object.keys(STATUSES)
      keys.forEach((key) => {
        let data = STATUSES[key]
        data['id'] = key
        li.push(data)
      })
      return li
    }
  },
  methods: {
    isSelected (item) {
      return this.selected.indexOf(item.id) !== -1
    },
    toggleSelected (item) {
      let selectedIndex = this.selected.indexOf(item.id)
      if (selectedIndex === -1) {
        this.selected.push(item.id)
      } else {
        this.selected.splice(selectedIndex, 1)
      }
      this.$emit('input', this.selected)
    }
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// StatusPicker.vue?0efda964